import React from 'react';
import { StyledContainer } from './SectionContainer.styles';

const SectionContainer = ({ children }) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default SectionContainer;
